import { useEffect } from 'react';
import {
  getPortraitStageContainer,
  getPortraitViewportContainer,
} from '../components/PortraitStage';

/** Keep in sync with pageMotion / route transition duration. */
const SCAN_SHELL_RELEASE_MS = 600;

function applyScanShell() {
  const viewport = getPortraitViewportContainer();
  const stage = getPortraitStageContainer();
  document.body.classList.add('scan-route');
  // Marker only — shared gallery --s is no longer remapped here.
  viewport?.classList.add('portraitViewport--scan', 'portraitViewport--fill');
  stage?.classList.add('portraitStage--scan');
}

function clearScanShell() {
  const viewport = getPortraitViewportContainer();
  const stage = getPortraitStageContainer();
  document.body.classList.remove('scan-route');
  viewport?.classList.remove(
    'portraitViewport--scan',
    'portraitViewport--fill',
    'portraitViewport--idle'
  );
  stage?.classList.remove('portraitStage--scan');
}

function hasActiveScanRoot() {
  return [...document.querySelectorAll('.scanRouteRoot')].some(
    (el) => !el.closest('[aria-hidden="true"]')
  );
}

function hasAnyScanPage() {
  return Boolean(document.querySelector('.scanPage, .scanRouteRoot'));
}

/** Marker classes for /scan; scale lives on .scanRouteRoot so home keeps gallery --s. */
export function useScanRouteViewport(scanActive) {
  useEffect(() => {
    if (hasActiveScanRoot()) {
      applyScanShell();
    }

    return () => {
      // Wait for exit animation so hint/info styles don't flash unscoped over home.
      window.setTimeout(() => {
        if (!hasAnyScanPage()) clearScanShell();
        else if (hasActiveScanRoot()) applyScanShell();
        else clearScanShell();
      }, SCAN_SHELL_RELEASE_MS);
    };
  }, []);

  useEffect(() => {
    const viewport = getPortraitViewportContainer();
    if (!viewport || !hasActiveScanRoot()) return;
    viewport.classList.toggle('portraitViewport--idle', !scanActive);
  }, [scanActive]);
}

export default useScanRouteViewport;
